import { DEFAULT_WALLET_PERMISSIONS } from '@sirius-cybernetics-42/product-config'

import type { WalletPermissionsEffective } from '@/data/marketApi/types'

export function getStaticWalletPermissions(address: string): WalletPermissionsEffective {
  return {
    address: address.toLowerCase(),
    ...DEFAULT_WALLET_PERMISSIONS,
  }
}

export function getDefaultWalletPermissions(): WalletPermissionsEffective {
  return {
    address: '',
    ...DEFAULT_WALLET_PERMISSIONS,
  }
}
